import React from 'react';
import {
  reduxForm,
  Field,
  isPristine,
  isValid,
  isInvalid,
  isSubmitting,
  submit,
} from 'redux-form';
import { connect } from 'react-redux';
import CustomTextField from '../common/custom-components/customTextField';
import PropTypes from 'prop-types';
import {
  required,
  password,
  passwordsMustMatch,
  companyName,
  street,
  streetline2,
  city,
  zipCode,
  maxLength5,
  phoneNumber,
  number,
  state,
  PassRequired,
  PASSWORD_POLICY,
  // isURL,
} from '../../constants/constants';
import './agent-profile.css';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';
import { bindActionCreators } from 'redux';
import { stateCodes } from '../../constants/states-constants';
import { CustomSelectField } from '../common/custom-components/customDropDown';
import InfoMessageBar from '../common/info-message/info-message';
export class AgentPasswordModal extends React.Component {
  handleSaveClick = () => {
    this.props.submit('updatePasswordForm');
  };

  // console.log(handleSubmit)
  render() {
    console.log('type is ', this.props);
    const { pristine, submitting, invalid, type } = this.props;
    return (
      <div>
        <form autoComplete="off" noValidate onSubmit={this.handleSubmit}>
          <Dialog
            open={this.props.open}
            onClose={this.props.close}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              {this.props.message && (
                <InfoMessageBar
                  variant="success"
                  icColor="successIc"
                  message={this.props.message}
                />
              )}
              {type === 'password' && (
                <React.Fragment>
                  <Typography
                    variant="h4"
                    className="text-xs-center"
                    color="primary"
                    gutterBottom
                    style={{ fontFamily: 'SerifaStd - Roman' }}
                  >
                    Update Password
                  </Typography>
                  <Typography
                    variant="body2"
                    component="p"
                    className="text-xs-center"
                  >
                    Use the form below to change the password for your Non Cash
                    Deposit Portal account. Use your new password the next time
                    you log in to the portal.
                  </Typography>
                  {this.props.errors && (
                    <InfoMessageBar
                      variant="error"
                      message={this.props.errors}
                    />
                  )}
                  <Field
                    className="TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="currPassword"
                    symbol="Current Password"
                    placeholder="Current Password"
                    required
                    fullWidth
                    type="password"
                    validate={[PassRequired, password]}
                    variant="outlined"
                  />
                  <Field
                    className="TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="newPassword"
                    symbol="New Password"
                    placeholder="New Password"
                    required
                    fullWidth
                    type="password"
                    validate={[PassRequired, password]}
                    variant="outlined"
                  />
                  <Box
                    component="div"
                    m={1}
                    color="text.primary"
                    style={{ border: '1px solid black', padding: 28 }}
                  >
                    <Typography
                      variant="body1"
                      component="p"
                      className="text-xs-center"
                    >
                      {PASSWORD_POLICY}
                    </Typography>
                  </Box>
                  <Field
                    className="TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="passwordConfirm"
                    symbol="Confirm Password"
                    placeholder="Confirm Password"
                    required
                    fullWidth
                    type="password"
                    validate={[PassRequired, password, passwordsMustMatch]}
                    variant="outlined"
                  />
                </React.Fragment>
              )}
              {type === 'company' && (
                <React.Fragment>
                  <Typography
                    variant="h4"
                    className="text-xs-center"
                    color="primary"
                    gutterBottom
                    style={{ fontFamily: 'SerifaStd - Roman' }}
                  >
                    Update Company and Mailing Address
                  </Typography>

                  <Field
                    className="TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="companyName"
                    symbol="CompanyName"
                    placeholder="Enter company name"
                    required
                    type="text"
                    validate={[required, companyName]}
                    variant="outlined"
                    style={{ width: '90%' }}
                  />

                  <Field
                    className=" TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="Str"
                    symbol="Address Line 1"
                    placeholder="Enter address line 1"
                    required
                    type="text"
                    validate={[required, street]}
                    variant="outlined"
                    style={{ width: '90%' }}
                  />

                  <Field
                    className="TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="str2"
                    symbol="Address Line 2"
                    placeholder="Enter address line 2"
                    type="text"
                    validate={[streetline2]}
                    variant="outlined"
                    style={{ width: '90%' }}
                  />

                  <Field
                    className="TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="city"
                    symbol="City"
                    placeholder="Enter city"
                    required
                    type="text"
                    validate={[required, city]}
                    variant="outlined"
                    style={{ width: '90%' }}
                  />

                  <Field
                    className="TextField-border-radius"
                    component={CustomSelectField}
                    label=""
                    name="state"
                    type="select"
                    variant="outlined"
                    required
                    validate={[required, state]}
                    style={{ width: '100%' }}
                  >
                    {stateCodes.map(item => (
                      <option key={item.abbreviation} value={item.abbreviation}>
                        {item.name}
                      </option>
                    ))}
                  </Field>

                  <Field
                    className="TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="zip"
                    symbol="ZipCode"
                    placeholder="ZipCode"
                    required
                    type="text"
                    validate={[required, number, maxLength5, zipCode]}
                    variant="outlined"
                    style={{ width: '90%' }}
                  />

                  <Field
                    className="TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="phonenumber"
                    symbol="PhoneNo #"
                    placeholder="Enter phone Number #"
                    required
                    type="text"
                    validate={[required, phoneNumber]}
                    variant="outlined"
                    style={{ width: '90%' }}
                  />

                  <Field
                    className="TextField-border-radius"
                    color="primary"
                    component={CustomTextField}
                    name="url"
                    symbol="Company Website"
                    placeholder="Enter company website"
                    type="text"
                    variant="outlined"
                    style={{ width: '90%' }}
                  />
                </React.Fragment>
              )}

              <div className="botton-group-profile">
                <Button
                  className="btn btn-lg "
                  disabled={invalid || submitting || pristine}
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={this.handleSaveClick}
                  fullWidth
                  style={{ padding: '15px 120px', borderRadius: 28 }}
                >
                  SAVE CHANGES
                </Button>
                <div className="link-pad-back">
                  <Link
                    component="button"
                    variant="body2"
                    onClick={this.props.cancel}
                    style={{
                      fontSize: 20,
                      fontFamily: 'Arial',
                      textAlign: 'center',
                      align: 'center',
                    }}
                  >
                    Cancel
                  </Link>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        </form>
      </div>
    );
  }
  // Callback for when the form is submitted
  //  onSubmit = (form) => alert(JSON.stringify(form, null, 2))
}
const mapStateToProps = state => ({
  pristine: isPristine('updatePasswordForm')(state),
  invalid: isInvalid('updatePasswordForm')(state),
  submitting: isSubmitting('updatePasswordForm')(state),
  formEnabled:
    isValid('updatePasswordForm')(state) &&
    !isSubmitting('updatePasswordForm')(state),
});

const mapDispatchToProps = dispatch => ({
  submit: bindActionCreators(submit, dispatch),
});

AgentPasswordModal.propTypes = {
  errors: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  handleBack: PropTypes.func,
  invalid: PropTypes.func,
  submitting: PropTypes.func,
  pristine: PropTypes.func,
  handleModalClose: PropTypes.func,
  submit: PropTypes.func,
  open: PropTypes.bool,
  close: PropTypes.bool,
  type: PropTypes.string,
  message: PropTypes.string,
  cancel: PropTypes.func,
};

const AgentModal = reduxForm({
  form: 'updatePasswordForm',
  enableReinitialize: true,
  // a unique identifier for this form
})(AgentPasswordModal);
export default connect(mapStateToProps, mapDispatchToProps)(AgentModal);
